import { Component, OnInit, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CustomValidatorService } from 'src/app/services/custom-validator.service';
import { AccountService } from '../../../../../services/account.service';
 
@Component({
  selector: 'app-bankinfo-creation-dialog',
  templateUrl: './bankinfo-creation-dialog.component.html',
  styleUrls: ['./bankinfo-creation-dialog.component.css']
})
export class BankinfoCreationDialogComponent implements OnInit {
  title: string;
  razorpay_merchantId: any;
  razorpay_merchantkey: any;
  razorpay_webhookKey: any;
  webhookKey: any;
  paymentMode: any;
  api_success: string;
  api_error: any;
  payU_placeholder = 'Enter MerchantId';
  payUTextVal = 'Set';
  razorPayTextVal='Set';
  merchantId: any;
  disableConfirmbtn = false;
  merchantKey: string;
  public bankdetailForm: UntypedFormGroup;
  paymentInfo: any;
  mode: string;
  constructor(private dialogRef: MatDialogRef<any>,
     @Inject(MAT_DIALOG_DATA) public data: any,
     private formBuilder: UntypedFormBuilder,
     private customValidator: CustomValidatorService,
      private accountService: AccountService) {
        this.createBankdetailsForm();
       }
  formErrors = {
    'accountHolderName': '',
    'bankAccountNumber': '',
    'bankName': '',
    'ifscCode': '',
    'branchCity': '',
    'panCardNumber': '',
    'nameOnPanCard':'',
    'payTmLinkedPhoneNumber':'',
    'paytmMerchantId':'',
    'paytmMerchantKey':'',
    'paytmWebsiteWeb':'',
    'paytmWebsiteApp':'',
    'paytmIndustryType':'',
    'razorpayMerchantId':'',
    'razorpayMerchantKey':'',
    'razorpayWebhookMerchantKey':'',
    'businessFilingStatus': '',
    'accountType': ''
  };
  ValidationMessages = {
    'accountHolderName': {
      'required': 'Bank Account Holder Name is Required',
      'whitespace': 'Bank Account Holder Name is invalid'

    },
    'bankAccountNumber': {
      'required': 'Account Number is Required',
      'whitespace': 'Account Number  is invalid'
    },
    'bankName': {
      'required': 'Bank Name is Required',
      'whitespace': 'Bank Name is invalid'
    },
    'ifscCode': {
      'required': 'Ifsc code is Required',
      'whitespace': 'Ifsc code is invalid'
    },
    'branchCity': {
      'required': 'Branch Name is Required',
      'whitespace': 'Branch Name is invalid'
    },
    'panCardNumber' : {
      'required': 'PAN number is Required',
      'whitespace': 'PAN number is invalid'
    },
    'payTmLinkedPhoneNumber' : {
      'required': 'Paytm linked phonenumber is Required',
      'whitespace': 'Paytm linked phonenumber is invalid'
    },
    'paytmMerchantId' : {
      'required': 'Paytm Merchantid is Required',
      'whitespace': 'Paytm Merchantid is invalid'
    },
    'paytmMerchantKey' : {
      'required': 'Paytm Merchantkey is Required',
      'whitespace': 'Paytm Merchantkey is invalid'
    },
    'paytmWebsiteWeb' : {
      'required': 'Paytm Website is Required',
      'whitespace': 'Paytm Website is invalid'
    },
    'paytmWebsiteApp' : {
      'required': 'Paytm app website is Required',
      'whitespace': 'Paytm app website is invalid'
    },
    'paytmIndustryType' : {
      'required': 'Paytm industry type is Required',
      'whitespace': 'Paytm industry type is invalid'
    },
    'razorpayMerchantId' : {
      'required': 'Razorpay Merchantid is Required',
      'whitespace': 'Razorpay Merchantid is invalid'
    },
    'razorpayMerchantKey' : {
      'required': 'Razorpay Merchantkey is Required',
      'whitespace': 'Razorpay Merchantkey is invalid'
    },
    'razorpayWebhookMerchantKey' : {
      'required': 'Razorpay WebhookMerchantkey is Required',
      'whitespace': 'Razorpay WebhookMerchantkey is invalid'
    },
    
  };
  createBankdetailsForm() {
    this.bankdetailForm = this.formBuilder.group({
      accountHolderName: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      bankAccountNumber: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      bankName: ['',[Validators.required, this.customValidator.noWhiteSpace]],
      ifscCode: ['',[Validators.required, this.customValidator.noWhiteSpace]],
      branchCity: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      panCardNumber: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      nameOnPanCard: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      payTmLinkedPhoneNumber: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      paytmMerchantId: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      paytmMerchantKey: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      paytmWebsiteWeb: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      paytmWebsiteApp: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      paytmIndustryType: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      razorpayMerchantId: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      razorpayMerchantKey: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      razorpayWebhookMerchantKey: ['', [Validators.required, this.customValidator.noWhiteSpace]],
      businessFilingStatus: ['Proprietorship'],
      accountType: ['Current'],
    });
  }
  ngOnInit() {
    if(this.data.mode){
      this.mode = this.data.mode;
    }
   if(this.data.bankId){
     this.accountService.getpaymentBankInfo(this.data.accountId,this.data.bankId)
     .subscribe(res => {
      this.paymentInfo = res;
      this.updateBankdetailsForm(this.paymentInfo);
       console.log(res);
     },
       (error) => {
         this.api_error = error.error;
       }
     );
   }

  }
  updateBankdetailsForm(paymentinfo) {
    this.bankdetailForm.patchValue({
      accountHolderName:paymentinfo.accountHolderName ||'' ,
      bankAccountNumber:paymentinfo.bankAccountNumber ||'' ,
      bankName:paymentinfo.bankName ||'',
      ifscCode:paymentinfo.ifscCode ||'' ,
      branchCity:paymentinfo.branchCity ||'' ,
      panCardNumber:paymentinfo.panCardNumber ||'',
      nameOnPanCard:paymentinfo.nameOnPanCard ||'' ,
      payTmLinkedPhoneNumber: paymentinfo.payTmLinkedPhoneNumber ||'' ,
      paytmMerchantId:paymentinfo.paytmMerchantId ||'' ,
      paytmMerchantKey:paymentinfo.paytmMerchantKey ||'' ,
      paytmWebsiteWeb:paymentinfo.paytmWebsiteWeb ||'' ,
      paytmWebsiteApp:paymentinfo.paytmWebsiteApp ||'' ,
      paytmIndustryType: paymentinfo.paytmIndustryType ||'',
      razorpayMerchantId:paymentinfo.razorpayMerchantId ||'' ,
      razorpayMerchantKey:paymentinfo.razorpayMerchantKey ||'',
      razorpayWebhookMerchantKey:paymentinfo.razorpayWebhookMerchantKey ||'',
      businessFilingStatus: paymentinfo.businessFilingStatus ||'Proprietorship',
      accountType: paymentinfo.accountType ||'Current'
    });
  }
  onBankdetailSubmit() {
    this.api_error = '';
    this.api_success = '';
    const form_data = this.bankdetailForm.value;
    if (this.data.bankId) {
      this.updatePaymentInfo(form_data);
    }
      else {
       this.createPaymentInfo(form_data);
     }
  }
  createPaymentInfo(form_data: any) {
    console.log(form_data);
    this.accountService.paymentInfocreate(this.data.accountId,form_data)
    .subscribe(res => {
      console.log(res);
      this.api_success = 'Payment info created Successfully';
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
      }, 2000);
    },
      (error) => {
        this.api_error = error.error;
      }
    );
   
  }
  updatePaymentInfo(form_data: any) {
    console.log(form_data);
    this.accountService.paymentInfoupdate(form_data,this.data.accountId,this.data.bankId)
    .subscribe(res => {
      console.log(res);
      this.api_success = 'Payment info updated Successfully';
      setTimeout(() => {
        this.dialogRef.close('reloadlist');
      }, 2000);
    },
      (error) => {
        this.api_error = error.error;
      }
    );
   
  }

  setMerchantId() {
    console.log(this.paymentMode);
    if (this.paymentMode === 'razorPay') {
      console.log('inside razorPay');
      this.razorPaySettings();
    } else {
      this.api_error = '';
      this.api_success = '';
      this.disableConfirmbtn = true;
      const data = {
        'accountId': this.data.accountId,
        'payUmerchantid': this.merchantId

      };
      this.accountService.setmerchantId(data)
        .subscribe(res => {
          this.api_success = 'MerchantId ' + this.payUTextVal + ' successfully';
          setTimeout(() => {
            this.dialogRef.close('reloadlist');
          }, 2000);
        },
          (error) => {
            this.api_error = error.error;
            this.disableConfirmbtn = false;
          });

    }
  }


  razorPaySettings() {
    this.api_error = '';
    this.api_success = '';
    this.disableConfirmbtn = true;
    const data = {
      'accountId': this.data.accountId,
      'merchantId': this.merchantId,
      'merchantKey': this.merchantKey,
      'webHookId':this.webhookKey

    };
 
    this.accountService.setRazorpayMerchantDetails(data)
      .subscribe(res => {
        console.log(res);
        this.api_success = 'Merchant Id and Key ' + this.razorPayTextVal + ' successfully';
        setTimeout(() => {
          this.dialogRef.close('reloadlist');
        }, 2000);
      },
        (error) => {
          this.api_error = error.error;
          this.disableConfirmbtn = false;
        });

  }
  logValidationErrors(group: UntypedFormGroup = this.bankdetailForm): void {
    Object.keys(group.controls).forEach((key: string) => {
      const abstractControl = group.get(key);
      this.formErrors[key] = '';
      if (abstractControl && !abstractControl.valid &&
        (abstractControl.touched || abstractControl.dirty)) {
        const messages = this.ValidationMessages[key];
        for (const errorKey in abstractControl.errors) {
          if (errorKey) {
            this.formErrors[key] += messages[errorKey] + ' ';
          }
        }
      }

      if (abstractControl instanceof UntypedFormGroup) {
        this.logValidationErrors(abstractControl);
      }
    });


  }
}
